import React, { useRef, useEffect, useCallback, useState} from 'react';
import Edge from './Edge.js';
import OutputNode from './OutputNode.js';
import {useWindowManager} from "components/windows/useWindowManager.js";
import PadComponent from "components/pads/PadComponent.js";
import {connect} from 'react-redux';

const PulledPad = ({
    setOrdering,
    ordering,
    scale,
    pad,
    scrollContainer,
    elements,
    sizeRef,
    size,
    setSize,
    isCurrent,
    padsExpand,
    coords,
    isSelected
}) => { 
    const ref = useRef(undefined);
    const {style, onContextMenu, onMouseDown, onMouseUp, setCoords} = useWindowManager({
        scale,
        ref,
        sequencerEngine: pad.sequencerEngine,
        windowPosition: coords,
        sizeRef,
        containerRef: scrollContainer,
        size,
        setSize,
        elements,
        element: pad,
        isPad: true,
        expand: padsExpand,
        setOrdering,
        ordering,
    });

    useEffect(() => {
        if (coords) {
            pad.x = coords.x;
            pad.y = coords.y;
        }
    }, [coords]);

    let className = "pulled-pad";
    if (isCurrent) {
        className += " current";
    }
    if (isSelected) {
        className += " selected";
    }
    let _style = {
        ... style,
    };
    if (coords) {
        _style.left = coords.x;
        _style.top =  coords.y;
    }
    return (
        <div
          style={_style}
          onMouseDown={onMouseDown}
          onContextMenu={onContextMenu}
          onMouseUp={onMouseUp}
          ref={ref} className={className}>
          <PadComponent isPulled={true} scrollContainer={scrollContainer} pad={pad}/>
          <OutputNode hideNumber={true} sequencerEngine={pad.sequencerEngine} node={pad}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      coords: state.windows.windowPositions[props.pad.id],
      isSelected: state.windows.selectedElements[props.pad.id],
      isCurrent: props.pad.subSequence === props.pad.sequencerEngine.currentSubSequence,
      padsExpand: state.pads.padsExpand
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PulledPad);
